<div class="bg-white h-full">
    <!-- Header -->
    <div class="px-4 py-3">
        <div class="flex items-center justify-between">
            <h2 class="text-sm font-semibold text-gray-900">
                <span *ngIf="!edit">Create new</span>
                <span *ngIf="edit">Edit</span>
                {{ options?.plan === 'agent' ? 'agent' : 'project' }}
            </h2>
            <button (click)="onGoBack()" 
                    class="p-1.5 hover:bg-gray-100 rounded-lg transition-colors">
                <i class="fa-solid fa-xmark text-gray-500 text-sm"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 py-3 overflow-y-auto" style="max-height: calc(90vh - 120px);">
        <form [formGroup]="instanceForm" class="space-y-4">
            <!-- Project Name Input -->
            <div>
                <label for="projectName" class="block text-[13px] font-medium text-gray-700 mb-1.5">
                    Project name <span class="text-red-500">*</span>
                    <span *ngIf="!edit" class="text-xs text-gray-500 font-normal ml-1">(cannot be changed later)</span>
                </label>
                <input type="text" 
                       id="projectName"
                       [disabled]="edit"
                       formControlName="organizationId"
                       (input)="toLowercase($event)"
                       placeholder="e.g., my-project"
                       class="w-full px-3 py-2 bg-white rounded-md text-[13px] focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-gray-100 disabled:text-gray-500"
                       style="background-color: white !important; border: 1px solid #d1d5db;">
                <div *ngIf="instanceForm.get('organizationId')?.invalid && instanceForm.get('organizationId')?.touched"
                     class="mt-1.5 text-xs text-red-600">
                    The project ID must be between 4 and 35 characters, cannot start with a number, and the only special character allowed is "-".
                    <br>Examples: myproject, my-project, my-project-2
                </div>
                <div *ngIf="isTestName"
                     class="mt-1.5 text-xs text-red-600">
                    {{ 'ERRORS.PROJECT_NAME_ALREADY_TAKEN' | translate }}
                </div>
            </div>


            <!-- Move Files Section (Only in Edit Mode) -->
            <div *ngIf="edit" class="border-t pt-4">
                <h3 class="text-[13px] font-medium text-gray-700 mb-2">Move files to another project</h3>
                <select [(ngModel)]="organizationIdSelectedForMoveFiles"
                        [ngModelOptions]="{standalone: true}"
                        class="w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-[13px] focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent mb-2"
                        style="background-color: white !important;">
                    <option value="">Select a project</option>
                    <option *ngFor="let instance of instancesAvailableForMoveFiles" 
                            [value]="instance.organizationId">
                        {{instance.organizationId}}
                    </option>
                </select>
                <button *ngIf="organizationIdSelectedForMoveFiles"
                        [disabled]="isLoading"
                        (click)="moveFilesToAnotherInstance(organizationIdSelectedForMoveFiles)"
                        type="button"
                        class="btn-secondary text-[13px]">
                    Move files to {{organizationIdSelectedForMoveFiles}}
                </button>
            </div>

            <!-- Price Information -->
            <div *ngIf="priceToPay && priceToPay > 0 && (!edit || showUpdatePlan)"
                 class="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p class="text-[13px] text-blue-900">
                    <span *ngIf="!showUpdatePlan">Creating this</span>
                    <span *ngIf="showUpdatePlan">Updating the plan of this</span>
                    project will cost you <strong>{{priceToPay}}€ + VAT monthly</strong> recurring to the card linked to your account.
                </p>
            </div>

            <!-- Loading Spinner -->
            <div *ngIf="isLoading" class="flex justify-center py-3">
                <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
            </div>
        </form>
    </div>

    <!-- Footer Actions -->
    <div class="px-4 py-3 border-t border-gray-200">
        <div class="flex gap-2 justify-end">
            <button (click)="onGoBack()" 
                    type="button"
                    class="h-8 px-4 rounded-md bg-white text-gray-700 text-[13px] transition-colors border border-gray-300 hover:bg-gray-50">
                Cancel
            </button>
            
            <button *ngIf="!edit"
                    [disabled]="isLoading || instanceForm.invalid || isTestName"
                    (click)="onSubmit()"
                    type="button"
                    class="h-8 px-4 rounded-md bg-primary text-white text-[13px] hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                {{ options?.plan === 'agent' ? 'Create Agent' : 'Create Project' }}
            </button>

            <button *ngIf="edit && !showUpdatePlan" 
                    [disabled]="isLoading || instanceForm.invalid"
                    (click)="onEdit()"
                    type="button"
                    class="h-8 px-4 rounded-md bg-primary text-white text-[13px] hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                Save Changes
            </button>

            <button *ngIf="showUpdatePlan" 
                    [disabled]="isLoading || instanceForm.invalid"
                    (click)="updatePlan()"
                    type="button"
                    class="h-8 px-4 rounded-md bg-primary text-white text-[13px] hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                Update Plan
            </button>
        </div>
    </div>

    <!-- Progress Bar -->
    <div *ngIf="isLoading" class="absolute bottom-0 left-0 right-0 h-1 bg-gray-200">
        <div class="h-full bg-primary animate-pulse"></div>
    </div>
</div>